import { api } from '../lib/api';
import type { PendingProcurementDetail, PendingProcurementGroup, ProcurementBatch } from '../types/api';

export async function listPendingProcurement(): Promise<PendingProcurementGroup[]> {
  const { data } = await api.get<PendingProcurementGroup[]>('/procurement/pending');
  return data;
}

// Itemised breakdown of one pending group - the review step shown before
// "Create batch" actually commits.
export async function getPendingProcurementLines(
  customerOrganisationId: string,
  siteId: string,
): Promise<PendingProcurementDetail> {
  const { data } = await api.get<PendingProcurementDetail>(
    `/procurement/pending/${customerOrganisationId}/${siteId}`,
  );
  return data;
}

export async function listProcurementBatches(): Promise<ProcurementBatch[]> {
  const { data } = await api.get<ProcurementBatch[]>('/procurement/batches');
  return data;
}

export async function getProcurementBatch(id: string): Promise<ProcurementBatch> {
  const { data } = await api.get<ProcurementBatch>(`/procurement/batches/${id}`);
  return data;
}

export interface CreateBatchInput {
  customerOrganisationId: string;
  siteId?: string;
}

export async function createProcurementBatch(input: CreateBatchInput): Promise<ProcurementBatch> {
  const { data } = await api.post<ProcurementBatch>('/procurement/batches', input);
  return data;
}

// §22: editable from the batch history list whether or not the item's been
// delivered yet.
export async function updateOrderLineCost(orderLineId: string, actualCost: number) {
  const { data } = await api.patch(`/procurement/order-lines/${orderLineId}/cost`, { actualCost });
  return data;
}
